'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._CardActionsMain = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _withExternalPropsCard = require('../../withExternalPropsCard');

var _withExternalPropsCard2 = _interopRequireDefault(_withExternalPropsCard);

var _CardActionsMainStyled = require('./styles/CardActionsMainStyled');

var _externalPropTypes = require('../../externalPropTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = _externalPropTypes.externalPropTypes;
var defaultProps = _externalPropTypes.externalDefaultProps;

var _CardActionsMain = exports._CardActionsMain = function _CardActionsMain(props) {
  return _react2.default.createElement(
    _CardActionsMainStyled.CardActionsMainStyled,
    { size: props.externalProps.size },
    props.children
  );
};

_CardActionsMain.displayName = 'CardActionsMain';
exports.default = (0, _withExternalPropsCard2.default)(_CardActionsMain);


_CardActionsMain.propTypes = propTypes;
_CardActionsMain.defaultProps = defaultProps;


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-card/dist/CardActions/CardActionsMain/CardActionsMain.js
// module id = 573
// module chunks = 0